import { Layout } from '@uhg-abyss/web/ui/Layout';
import { Skeleton } from '@uhg-abyss/web/ui/Skeleton';

import {
  SkeletonContainerDesktop,
  SkeletonContainerMobile,
} from './DataCard.style';

type Props = {
  fromMobileListView?: boolean;
  mobileScreen: boolean;
  isGroupedLocationDrawer?: boolean;
  notXlScreen?: boolean;
};

const DataCardSkeletonDesktop = ({
  isGroupedLocationDrawer = false,
  notXlScreen = false,
}: Props) => {
  const topSkeletonWidth = isGroupedLocationDrawer
    ? notXlScreen
      ? 400
      : 600
    : 238;
  const bottomSkeletonWidth = isGroupedLocationDrawer
    ? notXlScreen
      ? 475
      : 705
    : 360;

  return (
    <SkeletonContainerDesktop cssProps={{ isGroupedLocationDrawer }}>
      <Layout.Stack data-testid="skeleton-loader-data-card">
        <Layout.Group
          alignItems="top"
          css={{
            position: 'relative',
            left: '8px',
            top: '8px',
          }}
        >
          <Skeleton height={48} variant="alternate" width={48} />
          <Layout.Stack
            css={{
              position: 'relative',
              left: '11px',
              top: '4px',
            }}
            data-testid="skeleton-loader-cards"
            space={16}
          >
            <Skeleton
              height={16}
              variant="alternate"
              width={topSkeletonWidth}
            />
            <Skeleton
              height={16}
              variant="alternate"
              width={topSkeletonWidth}
            />
            <Skeleton
              height={16}
              variant="alternate"
              width={topSkeletonWidth}
            />
          </Layout.Stack>
        </Layout.Group>

        <Layout.Stack
          css={{
            position: 'relative',
            top: '34px',
            left: '11px',
          }}
          space={16}
        >
          <Skeleton
            height={16}
            variant="alternate"
            width={bottomSkeletonWidth}
          />
          <Skeleton
            height={16}
            variant="alternate"
            width={bottomSkeletonWidth}
          />
        </Layout.Stack>
      </Layout.Stack>
    </SkeletonContainerDesktop>
  );
};

const DataCardSkeletonMobile = () => (
  <SkeletonContainerMobile>
    <Layout.Stack data-testid="skeleton-loader-data-card-mobile">
      <Layout.Group
        alignItems="top"
        css={{
          position: 'relative',
          left: '-9px',
          top: '8px',
        }}
      >
        <Skeleton height={48} variant="alternate" width={48} />
        <Layout.Stack
          css={{
            position: 'relative',
            top: '4px',
            left: '10px',
          }}
          space={16}
        >
          <Skeleton height={16} variant="alternate" width={195} />
          <Skeleton height={16} variant="alternate" width={195} />
          <Skeleton height={16} variant="alternate" width={195} />
        </Layout.Stack>
      </Layout.Group>

      <Layout.Stack
        css={{
          position: 'relative',
          top: '22px',
          left: '16px',
        }}
        space={16}
      >
        <Skeleton height={16} variant="alternate" width={284} />
        <Skeleton height={16} variant="alternate" width={284} />
      </Layout.Stack>
    </Layout.Stack>
  </SkeletonContainerMobile>
);

export const DataCardSkeleton = ({
  fromMobileListView,
  mobileScreen,
  isGroupedLocationDrawer = false,
  notXlScreen = false,
}: Props) => {
  if (mobileScreen && !fromMobileListView) {
    return <DataCardSkeletonMobile />;
  }
  return (
    <DataCardSkeletonDesktop
      isGroupedLocationDrawer={isGroupedLocationDrawer}
      mobileScreen={false}
      notXlScreen={notXlScreen}
    />
  );
};
